module.exports = __webpack_public_path__ + "static/profil-483_optimized-bf7bec9e9b1607515b66ce5811c53c14.jpg";